module.exports = __webpack_public_path__ + "static/media/text.7acfad40.svg";